import useSWR from "swr";
import type { SwrReturnType } from "~/models/Api";
import type { ImportConversion } from "~/models/ImportConversion";
import type { ImportType } from "~/models/ImportLog";

const paths = {
	index: "/admin/import_conversions"
} as const;

type TIndex = (importType: ImportType) => SwrReturnType<ImportConversion[]>;
type ReturnType = {
	useIndex: TIndex;
};

export const useImportConversions = (): ReturnType => {
	const useIndex: TIndex = (importType: ImportType) => {
		const { data, mutate, error, isLoading } = useSWR<ImportConversion[]>({
			params: { importType },
			url: paths.index
		});
		return {
			data: data ?? null,
			error,
			isLoading,
			mutate: mutate ?? null
		};
	};
	return { useIndex };
};
